export const CATALOG_CODES = {
    VOD: 'VOD',
    SERIES: 'SERIES',
    TRAINER_BUNDLE_DISCOUNT: 'TRAINER_BUNDLE_DISCOUNT',
    COUPON: 'COUPON',
};
